import { Injectable } from '@angular/core';

export class PasswordStrength {
  symbols_level = 0;
  is_weak = false;
  is_strong = false;
}

@Injectable({
  providedIn: 'root'
})
export class PasswordStrengthService {
  constructor() { }

  checkPasswordStrength(password: string): PasswordStrength {
    const passwordStrength = new PasswordStrength();

    if (password.length < 8) {
      passwordStrength.is_weak = true;
    } else {
      passwordStrength.symbols_level = this.getPasswordSymbolsGroup(password);
      passwordStrength.is_weak = password.length < 10 && passwordStrength.symbols_level <= 2;
      passwordStrength.is_strong = password.length > 25 && passwordStrength.symbols_level > 1 || password.length > 10 && passwordStrength.symbols_level > 2;
    }

    return passwordStrength;
  }

  getPasswordSymbolsGroup(password: string): number {
    if (!password) {
      return 0;
    }

    let result = 0;

    const letterSymbolGroup = /[A-Za-z]/;
    const numberSymbolGroup = /\d/;
    const extraSymbolGroup = /[\!|\"|\?|\$|\%|\^|\&]/;

    if (password.match(letterSymbolGroup)) {
      result++;
    }

    if (password.match(numberSymbolGroup)) {
      result++;
    }

    if (password.match(extraSymbolGroup)) {
      result++;
    }

    return result;
  }
}
